import { routingConstants } from "../_constants";

const initialState = {
  routes: [],
  currentRoute: null,
  allRoutesLoading: false,
  allRoutesError: null,
  addRouteLoading: false,
  addRouteError: null,
  viewRouteLoading: false,
  viewRouteError: null,
  editRouteLoading: false,
  editRouteError: null,
};

const {
  GET_ALL_ROUTES_START,
  GET_ALL_ROUTES_SUCCESS,
  GET_ALL_ROUTES_FAILED,
  ADD_ROUTE_START,
  ADD_ROUTE_END,
  ADD_ROUTE_FAILED,
  VIEW_ROUTE_START,
  VIEW_ROUTE_SUCCESS,
  VIEW_ROUTE_FAILED,
  EDIT_ROUTE_START,
  EDIT_ROUTE_END,
  EDIT_ROUTE_SUCCESS,
  EDIT_ROUTE_FAILED,
} = routingConstants;

export default function routingReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_ROUTES_START:
      return {
        ...state,
        allRoutesLoading: true,
      };
    case GET_ALL_ROUTES_SUCCESS:
      return {
        ...state,
        allRoutesLoading: false,
        routes: action.payload,
      };
    case GET_ALL_ROUTES_FAILED:
      return {
        ...state,
        allRoutesLoading: false,
        allRoutesError: action.payload,
      };
    case ADD_ROUTE_START:
      return {
        ...state,
        addRouteLoading: true,
      };
    case ADD_ROUTE_END:
      return {
        ...state,
        addRouteLoading: false,
      };
    case ADD_ROUTE_FAILED:
      return {
        ...state,
        addRouteLoading: false,
        addRouteError: action.payload,
      };
    case VIEW_ROUTE_START:
      return {
        ...state,
        viewRouteLoading: true,
      };
    case VIEW_ROUTE_SUCCESS:
      return {
        ...state,
        viewRouteLoading: false,
        currentRoute: action.payload,
      };
    case VIEW_ROUTE_FAILED:
      return {
        ...state,
        viewRouteLoading: false,
        viewRouteError: action.payload,
      };
    case EDIT_ROUTE_START:
      return {
        ...state,
        editRouteLoading: true,
      };
    case EDIT_ROUTE_END:
      return {
        ...state,
        editRouteLoading: false,
      };
    case EDIT_ROUTE_SUCCESS:
      return {
        ...state,
        editRouteLoading: false,
        // currentRoute: action.payload,
      };
    case EDIT_ROUTE_FAILED:
      return {
        ...state,
        editRouteLoading: false,
        editRouteError: action.payload,
      };
    default:
      return state;
  }
}
